import { keyframes } from "@emotion/react";

import { Color, CSSRulesFunction, TypeScale } from "../theme";

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }

  100% {
    background-position: 468px 0;
  }
`;

export const shimmerStyle: CSSRulesFunction = (theme) => {
  return {
    animation: `${shimmer} 2s ease infinite forwards`,
    border: "none",
    padding: 0,
    margin: 0,
    borderCollapse: "collapse",
    width: "100%",
    height: theme.tokens.fontSizes[TypeScale.Size_02].lineHeight,
    background: theme.color(Color.Greystone_300),
    backgroundImage: `linear-gradient(to right, ${theme.color(
      Color.Greystone_300
    )} 0%, ${theme.color(Color.Greystone_200)} 20%, ${theme.color(
      Color.Greystone_300
    )} 40%, ${theme.color(Color.Greystone_300)} 100%)`,
    backgroundRepeat: "no-repeat",
    ...theme.tokens.fontSizes[TypeScale.Size_02],
    borderRadius: 4,
    backgroundSize: "1000px 100%",
  };
};
